import CmWrapBoxEpisodicItem from '../cm-wrap-box-episodic-items/cm-wrap-box-episodic-item.entity';
import CmWrapBox from '../cm-wrap-boxes/cm-wrap-box.entity';
import { DEPARTMENTS } from '../enums/enums';
import PrWrapBoxEpisodicProp from '../pr-wrap-box-episodic-props/pr-wrap-box-episodic-prop.entity';
import PrWrapBox from '../pr-wrap-boxes/pr-wrap-box.entity';
import SetWrapBoxSetPiece from '../set-wrap-box-set-pieces/set-wrap-box-set-piece.entity';
import SetWrapBox from '../set-wrap-boxes/set-wrap-box.entity';
import { SosCreateResponse, SosUpdateResponse } from '../sos-response';
import { InventoryDepartment } from '../types';

export type WrapBoxInventoryUpdateResponse = DeptSpecificWrapBoxInventoryUpdateResponse<
	InventoryDepartment
>;
export type WrapBoxInventoryCreateResponse = DeptSpecificWrapBoxInventoryCreateResponse<
	InventoryDepartment
>;

export interface DeptSpecificWrapBoxInventoryCreateResponse<
	T extends InventoryDepartment
> extends SosCreateResponse {
	created: T extends DEPARTMENTS.CM
		? {
				CmWrapBox: CmWrapBox[];
				CmWrapBoxEpisodicItem: CmWrapBoxEpisodicItem[];
		  }
		: T extends DEPARTMENTS.PR
		? {
				PrWrapBox: PrWrapBox[];
				PrWrapBoxEpisodicProp: PrWrapBoxEpisodicProp[];
		  }
		: T extends DEPARTMENTS.SET
		? {
				SetWrapBox: SetWrapBox[];
				SetWrapBoxSetPiece: SetWrapBoxSetPiece[];
		  }
		: never;
}

export interface DeptSpecificWrapBoxInventoryUpdateResponse<
	T extends InventoryDepartment
> extends SosUpdateResponse {
	created: T extends DEPARTMENTS.CM
		? {
				CmWrapBox: CmWrapBox[];
				CmWrapBoxEpisodicItem: CmWrapBoxEpisodicItem[];
		  }
		: T extends DEPARTMENTS.PR
		? {
				PrWrapBox: PrWrapBox[];
				PrWrapBoxEpisodicProp: PrWrapBoxEpisodicProp[];
		  }
		: T extends DEPARTMENTS.SET
		? {
				SetWrapBox: SetWrapBox[];
				SetWrapBoxSetPiece: SetWrapBoxSetPiece[];
		  }
		: never;

	destroyed: T extends DEPARTMENTS.CM
		? {
				CmWrapBoxEpisodicItem: CmWrapBoxEpisodicItem[];
		  }
		: T extends DEPARTMENTS.PR
		? {
				PrWrapBoxEpisodicProp: PrWrapBoxEpisodicProp[];
		  }
		: T extends DEPARTMENTS.SET
		? {
				SetWrapBoxSetPiece: SetWrapBoxSetPiece[];
		  }
		: never;

	updated: T extends DEPARTMENTS.CM
		? {
				CmWrapBoxEpisodicItem: CmWrapBoxEpisodicItem[];
		  }
		: T extends DEPARTMENTS.PR
		? {
				PrWrapBoxEpisodicProp: PrWrapBoxEpisodicProp[];
		  }
		: T extends DEPARTMENTS.SET
		? {
				SetWrapBoxSetPiece: SetWrapBoxSetPiece[];
		  }
		: never;
}
